var courseCtrl = (function () {
  return {
    list: function ($scope, Api) {
      $scope.courses = false;
      $scope.currentPage = 1;
      $scope.searchKw = '';
      $scope.searchMode = 'participating';
      $scope.total = 0;

      $scope.participatingCoursesCounter = 0;
      $scope.administratingCoursesCounter = 0;
      $scope.allCoursesCounter = 0;

      var requestCounters = function () {
        Api.get(`course?scope=participating&return_as=count`, function (err, resp) {
          if (!err) $scope.participatingCoursesCounter = resp.response;
        });

        Api.get(`course?scope=administrating&return_as=count`, function (err, resp) {
          if (!err) $scope.administratingCoursesCounter = resp.response;
        });

        Api.get(`course?scope=all&return_as=count`, function (err, resp) {
          if (!err) $scope.allCoursesCounter = resp.response;
        });
      };

      requestCounters();

      $scope.list = function (page, kw, mode) {
        $scope.blogs = false;
        $scope.currentPage = page;
        $scope.searchKw = kw;
        $scope.searchMode = mode;
        Api.get(`course?page=${page}&page_size=10&filter=${kw}&scope=${mode}`, function (err, resp) {
          if (!err) {
            $scope.courses = resp.response.data;
            $scope.total = resp.response.total;
          }
        });
      };

      $scope.redirectCourses = function () {
        window.location.href = '/courses';
      };

      // Change role
      $scope.course_exit = function (course_id) {
        Api.delete(`courses/${course_id}/users/${$scope.currentUser.user_id}/enrollment`, function (err, resp) {
          $scope.list(1, $scope.searchKw, $scope.searchMode);
          requestCounters();
        });
      };

      $scope.list(1, $scope.searchKw, $scope.searchMode);
    },

    new: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {
      $scope.preSave = function (payload) {
        if (payload.hasOwnProperty('category_id') && payload.category_id.length < 24) delete payload.category_id;
      };

      $scope.callbackSave = function (resp) {
        if (resp.status === 200) {
          var course_id = resp.response.course_id;
          window.location.href = `/manage.app#!/course/courses/${course_id}`;
        }
      };

      $scope.callbackError = function (error, ret) {
        if (ret.response && ret.response.error_code === 'COURSE_SLUG_ALREADY_EXISTS') {
          $translate('MESSAGES.COURSE_SLUG_ALREADY_EXISTS').then((result) => App.toastError(result, 5000));
          return;
        }
        $translate('GLOBAL.ERROR').then((result) => App.toastError(result, 5000));
      };
    },

    detail: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate, $http, $routeParams, formNotify) {
      var isAdmin = $scope.currentUser && ($scope.currentUser.role === 'ADM' || ($scope.currentUser.courses && $scope.currentUser.courses[$scope.id] && $scope.currentUser.courses[$scope.id].role === 'ADM'));

      var apiPathmonetization = 'monetization/iugu/products';

      var yScrollPosition = 0;

      var courseId = $scope.id;
      $scope.courseloading = 1;
      $scope.currentTab = 'tab1';
      $scope.monetizations = [];
      $scope.slug = null;
      $scope.user_searching = false;
      $scope.loadingUserStatistics = false;
      $scope.userStatistics = {
        total_users: 0,
        completion_rate: 0,
        progress_avg: 0
      };

      document.addEventListener('DOMContentLoaded', function () {
        var elems = document.querySelectorAll('.collapsible');
        var instances = M.Collapsible.init(elems, options);
      });

      // Or with jQuery

      $(document).ready(function () {
        $('.collapsible').collapsible();
      });

      $scope.accountMonetization = '';
      $scope.newAccountMonetization = false;

      Api.get(`course/${courseId}/monetization-account`, function (err, ret) {
        if (!err) {
          $scope.accountMonetization = ret.response.data;
        }
      });
      // Show user data from item select on suggest input
      $scope.preAddUserMonetization = function (user) {
        Api.get(`user/get/${user.id}`, function (err, data) {
          $scope.accountMonetization = {
            account_id: user.accountId,
            user_id: data.response._id,
            user_name: data.response.name,
            user_email: data.response.email,
            user_slug: data.response.slug,
            user_image: data.response.image,
            company_document: user.companyDocument,
            company_name: user.companyName
          };
          $scope.newAccountMonetization = true;
        });
      };

      $scope.saveMonetization = function () {
        const data = {
          target_monetization_account_id: $scope.accountMonetization.account_id
        };
        Api.put(`course/${courseId}/monetization-account`, data, function (err, ret) {
          if (err) {
            $scope.accountMonetization = '';
            $translate('GLOBAL.ERROR').then((result) => App.toastError(result, 8000));
            return;
          }
          $translate('MESSAGES.OK_DEFAULT').then(function (result) {
            App.toast(result, 3000);
          });
          $scope.newAccountMonetization = false;
        });
      };

      $scope.removeMonetizationAccount = function () {
        const data = {
          target_monetization_account_id: null
        };
        const dataCourse = {
          signup_policy: 0
        };
        Api.put(`course/${courseId}/monetization-account`, data, function (err, ret) {
          if (err) {
            $translate('GLOBAL.ERROR').then((result) => App.toastError(result, 8000));
            return;
          }
          Api.put(`course/${courseId}`, dataCourse, function (err, data) {
            if (!err) {
              $translate('MESSAGES.OK_DEFAULT').then(function (result) {
                App.toast(result, 3000);
              });
              $scope.course.signup_policy = 0;
              $scope.accountMonetization = '';
            }
          });
        });
      };

      $('#user_search').autocomplete({
        search: function () {
          $scope.user_searching = true;
        },
        response: function () {
          $scope.user_searching = false;
        }
      });

      $scope.clearMonetizationAffiliate = function () {
        $scope.newUser = false;
      };

      $scope.FilterCurrencyLevel = function (item) {
        return item.currency === 'brl';
      };

      // Save URL Hotmart
      $scope.saveUrlHotmart = function (urlHotmart) {
        Api.post(
          `webhook/hotmart/custom-purchase-url`,
          {
            custom_purchase_url: urlHotmart,
            courseId: courseId
          },
          function (err, ret) {
            if (err) {
              $translate('COURSE.EDIT_URL_ADDED_ERROR').then(function (result) {
                App.toast(result, 3000);
              });
              return;
            }
            if (!err && ret) {
              $translate('COURSE.EDIT_URL_ADDED').then(function (result) {
                App.toast(result, 3000);
              });
            }
          }
        );
      };

      // For mobile change tabs
      $scope.changeTab = function (tab) {
        $('ul.tabs').tabs('select_tab', tab);
      };

      // editing = false;

      // Get course data
      Api.get(`course/${courseId}`, function (err, data) {
        if (!err) {
          $scope.course = data.response;
          $scope.courseloading = 0;
          $scope.project_id = $scope.course.project_id;
          $scope.showMonetizationTabs = $scope.currentUser.stripe_connected_account_id && ($scope.course.signup_policy === 3 || $scope.course.signup_policy === 0);
          $scope.getAllPricingForCurrentCourse(data.response.slug);
        }
      });

      // Get User statistics
      $scope.loadingUserStatistics = true;
      Api.get(`courses/${courseId}/statistics/summary`, function (err, ret) {
        if (!err) {
          $scope.userStatistics = ret.response.data;
        }
        $scope.loadingUserStatistics = false;
      });

      //Get count student statistics
      $scope.userCountStatistics = 0;
      $scope.loadingUserCountStatistics = true;
      Api.get(`course/${courseId}/users/?return_as=count&signup_pending=false&role=USR`, function (err, ret) {
        if (!err) {
          $scope.userCountStatistics = ret.response.data;
        }
        $scope.loadingUserCountStatistics = false;
      });

      $scope.getAllPricingForCurrentCourse = function (slug) {
        $scope.slug = slug;
        Api.get(`${apiPathmonetization}/course/${courseId}`, function (err, data) {
          if (!err) {
            $scope.monetizations = data.response.data.products.filter((p) => p.enabled);
          }
        });
      };

      // NPS Search
      $scope.filterDateNpsIni = ''; 
      $scope.filterDateNpsEnd = '';
      $scope.filterNpsSelected = '';
      $scope.questionsNPS = [];
      $scope.currentPageNPS = 1;
      $scope.totalClassesNps = 0;
      $scope.modulesNPS = [];
      $scope.courseNPS = 0;
      $scope.courseReviews = 0;
      $scope.loadingNPS = false;

      var today = new Date();
      var initialDate = new Date(new Date().setDate(today.getDate() - 30));

      var endDateNps = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 20, 59, 59);
      var iniDateNps = new Date(initialDate.getFullYear(), initialDate.getMonth(), initialDate.getDate(), 21, 0, 0);

      $scope.filterDateNpsIni = iniDateNps.toISOString();
      $scope.filterDateNpsEnd = endDateNps.toISOString();

      $scope.getAllNps = function (page, pageSize, dateIni, dateEnd) {
        let circleBox = document.body.style;
        $scope.loadingNPS = true;
        if ($scope.lang === 'pt-br' && dateIni && typeof dateIni === 'string') {
          dateIni = new Date(dateIni.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3'));
          dateIni = dateIni.toISOString();
        }
        if ($scope.lang === 'pt-br' && dateEnd && typeof dateEnd === 'string') {
          dateEnd = new Date(dateEnd.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3'));
          dateEnd = dateEnd.toISOString();
        }
        Api.get(`user_experience_review/net_promoter_score/questions/${$scope.filterNpsSelected}/?start_date=${dateIni}&end_date=${dateEnd}&course_id=${courseId}&page=${page}&page_size=${pageSize}`, function (err, ret) {
          if (!err) {
            $scope.totalClassesNps = ret.response.data.total_classes;
            $scope.modulesNPS = ret.response.data.modules;
            $scope.courseNPS = ret.response.data.summary ? ret.response.data.summary.nps : null;
            $scope.courseReviews = ret.response.data.summary ? ret.response.data.summary.total_reviews : null;
            circleBox.setProperty('--NPS', $scope.courseNPS);
          }
          $scope.loadingNPS = false;
        });
      };

      $scope.changeNpsQuestion = function (filterNpsSelected) {
        $scope.filterNpsSelected = filterNpsSelected;
      };

      $scope.getQuestionsNPS = function () {
        Api.get('custom-survey-questions/lightweight/nps', function (err, ret) {
          if (!err) {
            $scope.questionsNPS = ret.response.data;
          }
        });
      };

      $scope.getQuestionsNPS();

      $scope.searchNps = function (Form, currentPageNPS, pageSize, filterDateNpsIni, filterDateNpsEnd) {
        if (Form.$invalid) {
          formNotify($scope, Form);
          return false;
        } else {
          return $scope.getAllNps(currentPageNPS, pageSize, filterDateNpsIni, filterDateNpsEnd);
        }
      };

      // NPS Search by class
      $scope.courseId = $scope.id;
      $scope.classTitle = '';
      $scope.classId = '';
      $scope.totalReviewsNPS = 0;
      $scope.reviewsNPS = [];
      $scope.toggle = false;
      $scope.loadingNPS = false;

      $scope.pageNPSModal = 1;
      $scope.pageSizeModal = 10;

      $scope.openModalNpsReview = function (classTitle, classId) {
        $scope.loadingNPS = true;
        $scope.classTitle = classTitle;
        $scope.classId = classId;
        $('#npsReviews').openModal();
        $scope.getNpsReview(classId);
      };

      $scope.getNpsReview = function (classId, page) {
        if (!page) page = 1;
        Api.get(`user_experience_review/questions/${$scope.filterNpsSelected}?course_id=${courseId}&class_id=${classId}&page_size=${$scope.pageSizeModal}&page=${page}`, function (err, ret) {
          if (!err) {
            $scope.totalReviewsNPS = ret.response.data.total;
            $scope.reviewsNPS = ret.response.data.reviews;
          }
          $scope.loadingNPS = false;
        });
      };

      $scope.closeNpsReviews = function () {
        $('#npsReviews').closeModal();
      };

      // Review Search
      $scope.filterDateReviewIni = ''; 
      $scope.filterDateReviewEnd = '';
      $scope.filterReviewSelected = '';
      $scope.questionsReview= [];
      $scope.currentPageReview = 1;
      $scope.totalClassesReview = 0;
      $scope.modulesReview = [];
      $scope.loadingReview = false;


      var today = new Date();
      var initialDate = new Date(new Date().setDate(today.getDate() - 30));

      var endDateReview = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 20, 59, 59);
      var iniDateReview = new Date(initialDate.getFullYear(), initialDate.getMonth(), initialDate.getDate(), 21, 0, 0);

      $scope.filterDateReviewIni = iniDateReview.toISOString();
      $scope.filterDateReviewEnd = endDateReview.toISOString();

      $scope.getAllReview = function (page, pageSize, dateIni, dateEnd) {
        $scope.loadingReview = true;
        if ($scope.lang === 'pt-br' && dateIni && typeof dateIni === 'string') {
          dateIni = new Date(dateIni.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3'));
          dateIni = dateIni.toISOString();
        }
        if ($scope.lang === 'pt-br' && dateEnd && typeof dateEnd === 'string') {
          dateEnd = new Date(dateEnd.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3'));
          dateEnd = dateEnd.toISOString();
        }
        Api.get(`user_experience_review/net_promoter_score/questions/${$scope.filterReviewSelected}/?start_date=${dateIni}&end_date=${dateEnd}&course_id=${courseId}&page=${page}&page_size=${pageSize}`, function (err, ret) {
          if (!err) {
            $scope.totalClassesReview = ret.response.data.total_classes;
            $scope.modulesReview = ret.response.data.modules;
          }
          $scope.loadingReview = false;
        });
      };

      $scope.changeReviewQuestion = function (filterReviewSelected) {
        $scope.filterReviewSelected = filterReviewSelected;
      };

      $scope.getQuestionsReview = function () {
        Api.get('custom-survey-questions/lightweight/text', function (err, ret) {
          if (!err) {
            $scope.questionsReview = ret.response.data;
          }
        });
      };

      $scope.getQuestionsReview();

      $scope.searchReview = function (Form, currentPageReview, pageSize, filterDateNpsIni, filterDateNpsEnd) {
        if (Form.$invalid) {
          formNotify($scope, Form);
          return false;
        } else {
          return $scope.getAllReview(currentPageReview, pageSize, filterDateNpsIni, filterDateNpsEnd);
        }
      };

      // Review Search by class
      $scope.courseId = $scope.id;
      $scope.classTitle = '';
      $scope.classId = '';
      $scope.totalReviewsQuestions = 0;
      $scope.reviewsQuestions = [];
      $scope.toggle = false;
      $scope.loadingReview = false;

      $scope.pageReviewModal = 1;
      $scope.pageSizeModal = 10;

      $scope.openModalQuestionReview = function (classTitle, classId) {
        $scope.loadingReview = true;
        $scope.classTitle = classTitle;
        $scope.classId = classId;
        $('#questionReviews').openModal();
        $scope.getQuestionReview(classId);
      };

      $scope.getQuestionReview = function (classId, page) {
        if (!page) page = 1;
        Api.get(`user_experience_review/questions/${$scope.filterReviewSelected}?course_id=${courseId}&class_id=${classId}&page_size=${$scope.pageSizeModal}&page=${page}`, function (err, ret) {
          if (!err) {
            $scope.totalReviewsQuestions = ret.response.data.total;
            $scope.reviewsQuestions = ret.response.data.reviews;
          }
          $scope.loadingReview = false;
        });
      };

      $scope.closeQuestionReviews = function () {
        $('#questionReviews').closeModal();
      };

      // Publish Course
      $scope.publishCourse = function () {
        var courseReady = false;
        for (var m in $scope.modules) {
          for (var c in $scope.modules[m].course_classes) {
            if ($scope.modules[m].course_classes[c].status === 1 && $scope.modules[m].status === 1) {
              courseReady = true;
              break;
            }
          }
        }
        if (courseReady) {
          Api.put(`course/${courseId}`, {status: 1}, function (err) {
            if (!err) $scope.course.status = 1;
          });
        } else {
          $translate('COURSE.ERROR_COURSE_READY').then(function (result) {
            App.toast(result, 3000);
          });
        }
      };

      // Get course users
      $scope.searchLoading = false;
      $scope.courseGroupFilter = '';
      $scope.courseFilterMonetizationStatus = '';
      $scope.courseFilterRole = '';

      $scope.getUsers = function (page, pageSize, role, filter, target, monetization, courseGroupId) {
        $scope.courseGroupFilter = courseGroupId;

        if (role) {
          $scope.courseFilterRole = role !== 'ALL' ? role : '';
        }
        if (monetization) {
          $scope.courseFilterMonetizationStatus = monetization !== 'ALL' ? monetization : '';
        }
        $scope.searchLoading = true;

        if (!page) {
          page = 1;
        }
        let queryString = '';
        if ($scope.courseFilterRole) {
          queryString += `&role=${$scope.courseFilterRole}`;
        }
        if (page) {
          queryString += `&page=${page}`;
        }
        if (pageSize) {
          queryString += `&page_size=${pageSize}`;
        }
        if (filter) {
          queryString += `&text_filter=${filter}`;
        }
        if ($scope.courseFilterMonetizationStatus && $scope.courseFilterRole !== 'ADM') {
          queryString += `&monetization_status=${$scope.courseFilterMonetizationStatus}`;
        }
        if (courseGroupId && $scope.courseFilterRole === 'USR') {
          queryString += `&course_group_id=${courseGroupId}`;
        }

        Api.get(`course/${courseId}/users?return_as=list&signup_pending=false${queryString}`, function (err, resp) {
          if (!err) {
            $scope[target] = resp.response.data;
          }
          $scope.searchLoading = false;
        });
      };

      $scope.getUsers(1, 30, 'ALL', '', 'courseUsers');
      $scope.getUsers(1, 100, 'ADM', '', 'courseAdmins');
      $scope.courseFilterRole = '';

      $scope.preSave = function (payload) {
        if (payload.status) payload.status = 1;
        else payload.status = 0;

        if (payload.hasOwnProperty('category_id') && (!payload.category_id || payload.category_id.length < 24)) delete payload.category_id;

        if (payload.video_url && !/youtube.com\/watch|docs.google.com\/presentation|vimeo.com|youtu.be\//.test(payload.video_url)) {
          $translate('COURSE.ERROR_VIDEO_URL').then(function (result) {
            App.toast(result, 3000);
          });
          return 'ERROR';
        } else if (!payload.author_id) {
          $translate('COURSE.ERROR_AUTHOR').then(function (result) {
            App.toast(result, 3000);
          });
          return 'ERROR';
        }
        $scope.showMonetizationTabs = true;
      };

      // Show user data from item select on suggest input
      $scope.preAddUser = function (user) {
        Api.get(`user/get/${user.id}`, function (err, data) {
          $scope.newUser = data.response;
        });
      };

      // Open modal for add new user as ADM ou Enrolment
      $scope.openUser = function (role) {
        $scope.activeRole = role;
        $scope.newUser = false;
        $scope.new_user = '';
        $('#add_user').openModal();
      };

      $scope.courses_group = [];
      $scope.current_course_group = {};
      $scope.isManage = false;

      $scope.loadCoursesGroup = function () {
        Api.get(`courses/${courseId}/course-groups`, function (err, resp) {
          if (!err) {
            $scope.courses_group = resp.response.data;
          }
        });
      };

      // Add new user
      $scope.addNewUser = function (user) {
        if (!user) {
          $translate('COURSE.ERROR_SELECT_USER').then(function (result) {
            App.toast(result, 3000);
          });
          return;
        }

        var payload = {
          role: $scope.activeRole,
          signup_pending: false
        };

        var existsAsUser = false;
        var existsAsAdm = false;
        var methodCall = 'post';

        for (var usr in $scope.courseUsers.items) {
          if ($scope.courseUsers.items[usr].id === user._id) {
            existsAsUser = true;
            break;
          }
        }
        for (var usr in $scope.courseAdmins.items) {
          if ($scope.courseAdmins.items[usr].id === user._id) {
            existsAsAdm = true;
            break;
          }
        }

        // User already exists as USR, change role to ADM
        if ($scope.activeRole === 'ADM' && existsAsUser) methodCall = 'put';

        // User already exists as ADM, send warning msg
        if ($scope.activeRole !== 'ADM' && existsAsAdm) {
          $translate('MESSAGES.USER_ALREADY_IN_COURSE_AS_ADM').then(function (result) {
            App.toast(result, 3000);
          });
          return false;
        }

        Api[methodCall](`courses/${courseId}/users/${user._id}/enrollment`, payload, function (err, ret) {
          if (!err) {
            $('#add_user').closeModal();
            $scope.newUser = false;
            $scope.new_user = '';
            if ($scope.activeRole === 'ADM') $scope.getUsers(1, 100, 'ADM', '', 'courseAdmins');
            else $scope.getUsers(1, 30, 'USR', '', 'courseUsers');
          }
        });

        $scope.loadCoursesGroup();
      };

      // Custom function for role remove for snippetuserlist directive
      $scope.remove_role = function (user_id) {
        Api.delete(`courses/${courseId}/users/${user_id}/enrollment`, function (err, resp) {
          $scope.getUsers(1, 100, 'ADM', '', 'courseAdmins');
          $scope.getUsers(1, 30, 'USR', '', 'courseUsers');
        });
      };

      $scope.subscriptionSuspension = function (subscriptionId) {
        Api.post(`monetization/subscriptions/${subscriptionId}/suspension`, {}, function (err, resp) {
          if (!err && resp) {
            $translate('MESSAGES.USER_COURSES_CANCELLATION_REQUESTED').then(function (result) {
              App.toast(result, 3000);
            });
            $scope.getUsers(1, 30, 'USR', '', 'courseUsers', $scope.searchFilter, $scope.courseGroupFilter);
          } else {
            $translate('GLOBAL.ERROR').then((result) => App.toast(result, 5000));
          }
        });
      };

      $scope.cancel_unsubscribe_request = function (subscriptionId) {
        Api.post(`monetization/subscriptions/${subscriptionId}/remove-suspension`, {}, function (err, resp) {
          if (!err && resp) {
            $translate('MESSAGES.ROLE_UPDATED_UNDO_CANCEL').then(function (result) {
              Materialize.toast(result, 3000);
            });
            $scope.getUsers(1, 30, 'USR', '', 'courseUsers', $scope.searchFilter, $scope.courseGroupFilter);
          } else {
            $translate('GLOBAL.ERROR').then((result) => App.toast(result, 5000));
          }
        });
      };

      $scope.coursesAccessEmail = function (subscriptionId) {
        Api.post(`monetization/subscriptions/${subscriptionId}/courses-access-email`, {}, function (err, resp) {
          if (!err && resp) {
            $translate('MESSAGES.USER_COURSES_ACCESS_EMAIL').then(function (result) {
              App.toast(result, 3000);
            });
          }
        });
      };

      // List modules and classes
      var listModules = function () {
        Api.get(`course_module?course_id=${courseId}`, function (err, ret) {
          if (err) return false;
          $scope.modules = ret.response.data;
        });
      };
      listModules();

      $scope.openModule = function (moduleId) {
        $scope.newModule = {};
        if (moduleId) {
          Api.get(`course_module/${moduleId}`, function (err, ret) {
            if (err) return false;
            $scope.newModule = ret.response;
          });
        }
        $('#module_modal').openModal();
      };
      $scope.saveModule = function (data, Form) {
        if (Form.$invalid) {
          formNotify($scope, Form);
          return false;
        }
        $('#module_modal').closeModal();
        if (data._id) {
          Api.put(`course_module/${data._id}`, data, function (err, ret) {
            if (!err) listModules();
            $scope.newModule = {};
          });
        } else {
          Api.post(`course_module?course_id=${courseId}`, data, function (err, ret) {
            if (!err) listModules();
            $scope.newModule = {};
          });
        }
      };
      $scope.deleteModule = function (moduleId) {
        Api.delete(`course_module/${moduleId}`, function (err, ret) {
          if (err) {
            if (ret.response && ret.response.error_code === 'CANNOT_DELETE_MODULE_WITH_CLASSES') {
              $translate('MESSAGES.CANNOT_DELETE_MODULE_WITH_CLASSES').then(function (result) {
                App.toastError(result, 8000);
              });
            }
            return;
          }
          listModules();
        });
      };

      // Open/close takeover for course class
      $scope.closeClass = function () {
        window.scrollTo(0, yScrollPosition);
        $scope.editClass = false;
        $scope.takeoverOpen = false;
        $scope.class = {};
      };

      $scope.openClass = function (class_id, module_id) {
        yScrollPosition = window.scrollY;
        // Reset scroll
        window.scrollTo(0, 0);
        $scope.classloading = 1;
        $scope.takeoverOpen = true;
        $scope.course_class = {
          title: '',
          content: '',
          embed_type: 'no_embed',
          can_be_completed: true,
          status: 1
        };
        if (module_id) {
          $scope.course_class.module_id = module_id;
          $scope.newClassModule = module_id;
        }
        if (class_id) {
          Api.get(`course_class/${class_id}`, function (err, ret) {
            $scope.course_class = ret.response.data;
            $scope.classloading = 0;
          });
        } else {
          $scope.classloading = 0;
        }
        $scope.editClass = true;
      };

      $scope.closeContentType = function (data) {
        data.embed_type = 'no_embed';
        data.video_url = '';
        data.generated_class_id = '';
        data.stream_server_url = '';
        data.stream_key = '';
        data.stream_playback_url = '';
        data.stream_channel_arn = '';
      };

      $scope.openModal = function (idModal, data) {
        data.video_url = '';
        if (idModal === '#streamLink' || '#modalStreamPlatform') {
          let url = '';
          if (data.id) {
            url = `course_class/${courseId}/streaming/${data.id}`;
          } else {
            url = `course_class/${courseId}/streaming`;
          }
          Api.get(url, function (err, ret) {
            if (!err) {
              data.generated_class_id = ret.response.data.generated_class_id;
              data.stream_server_url = ret.response.data.stream_server_url;
              data.stream_key = ret.response.data.stream_key;
              data.stream_playback_url = ret.response.data.stream_playback_url;
              data.stream_channel_arn = ret.response.data.stream_channel_arn;
              $(idModal).openModal();
            }
          });
        } else {
          $(idModal).openModal();
        }
      };

      $scope.saveMidiaValidation = function (data, idModal, embedType) {
        if (data.video_url && !/youtube.com\/watch|docs.google.com\/presentation|vimeo.com|youtu.be\//.test(data.video_url)) {
          $translate('COURSE.ERROR_VIDEO_URL').then(function (result) {
            App.toast(result, 3000);
          });
          return false;
        } else {
          data.embed_type = embedType;
          $translate('COURSE.SAVED_VIDEO_URL').then(function (result) {
            App.toast(result, 3000);
          });
          $(idModal).closeModal();
        }
      };

      $scope.saveClass = function (data) {
        if (!data || !data.title) {
          $translate('MESSAGES.COURSE_CLASS_TITLE_REQUIRED').then(function (result) {
            App.toast(result, 3000);
          });
          return false;
        } else if (data.title.length < 4 || data.title.length > 100) {
          $translate('COURSE.ERROR_TITLE').then(function (result) {
            App.toast(result, 3000);
          });
          return false;
        }
        if (data.id) {
          Api.put(`course_class/${data.id}`, data, function (err, ret) {
            $scope.closeClass();
            listModules();
          });
        } else {
          Api.post(`course_class?course_module_id=${$scope.newClassModule}`, data, function (err, ret) {
            $scope.closeClass();
            listModules();
          });
        }
      };
      $scope.deleteClass = function (classId) {
        Api.delete(`course_class/${classId}`, function (err, ret) {
          if (err) {
            if (ret.response && ret.response.error_code === 'CANNOT_DELETE_ACTIVE_CLASS') {
              $translate('MESSAGES.CANNOT_DELETE_ACTIVE_CLASS').then(function (result) {
                App.toastError(result, 8000);
              });
            }
            return;
          }
          listModules();
        });
      };

      $scope.uploadFile = function (file, invalid) {
        var files = $scope.course_class.files || [];
        var exists = false;
        $scope.uploadingFile = true;

        // Check if file already in class
        for (var i in files) if (files[i].file_alias === file.name) exists = true;
        if (exists) {
          $translate('MESSAGES.COURSE_CLASS_FILE_ALREADY_IN_CLASS').then(function (result) {
            App.toast(result, 5000);
          });
          return false;
        } else if (files.length === 10) {
          // Check max files per class
          $translate('MESSAGES.COURSE_CLASS_MAX_FILE_PER').then(function (result) {
            App.toast(result, 5000);
          });
          return false;
        } else if (invalid) {
          if (invalid.$error === 'maxSize')
            // Error max size
            $translate('MESSAGES.COURSE_CLASS_FILE_MAXSIZE').then(function (result) {
              App.toast(result, 5000);
            });
          else if (invalid.$error === 'pattern')
            // Error file pattern
            $translate('MESSAGES.COURSE_CLASS_FILE_PATTERN').then(function (result) {
              App.toast(result, 5000);
            });
          return false;
        }
        ReqAndUpload.upload(file, 'course', courseId).then(function (filename) {
          if (filename) {
            if (!$scope.course_class.files) $scope.course_class.files = [];
            $scope.course_class.files.push({
              file_alias: file.name,
              file_name: filename
            });
          }
          $scope.uploadingFile = false;
        });
      };
      $scope.removeFile = function (index) {
        $scope.course_class.files.splice(index, 1);
      };

      var updatingModules = false;
      var updateModules = function () {
        if (updatingModules) clearTimeout(updatingModules);
        updatingModules = window.setTimeout(function () {
          var payload = {
            course_modules: []
          };
          $('.modules-sortable > li').each(function () {
            var moduleObj = $(this);
            var moduleId = moduleObj.attr('data-moduleid');
            var classes = [];
            if (moduleObj.find('ul').length > 0) {
              moduleObj.find('li:not(.empty_module)').each(function () {
                var classId = $(this).attr('data-classid');
                classes.push(classId);
              });
            }
            payload.course_modules.push({
              id: moduleId,
              course_classes: classes
            });
          });
          Api.put(`course_module?course_id=${courseId}`, payload, function (err, resp) {
            if (err) {
              $translate('GLOBAL.ERROR').then((result) => App.toastError(result, 5000));
            }
            listModules();
          });
        }, 2000);
      };

      // Drag'n Drop modules and classes
      $scope.moduleSortableOptions = {
        handle: '.handle',
        placeholder: 'collection-item',
        forcePlaceholderSize: true,
        stop: updateModules
      };
      $scope.classSortableOptions = {
        handle: '.handle',
        placeholder: 'collection-item',
        forcePlaceholderSize: true,
        connectWith: '.classes-sortable',
        stop: updateModules
      };

      $scope.lang = bcp.settings.language;

      $scope.loadCoursesGroup();

      $scope.addCourseGroup = function () {
        let letterGroup = getLetterGroup($scope.courses_group.length);
        Api.post(`courses/${courseId}/course-groups`, {title: `${letterGroup}`}, function (err, resp) {
          if (!err) {
            $translate(`COURSE.${resp.response.result}`).then(function (result) {
              $scope.loadCoursesGroup();
              App.toast(result, 3000);
            });
          }
        });
      };

      $scope.removeClass = function (id) {
        Api.delete(`courses/${courseId}/course-groups/${id}`, function (err, resp) {
          if (err) {
            $translate(`COURSE.${err.response.error_code}`).then(function (result) {
              App.toast(result, 3000);
            });
          }

          if (!err) {
            $translate(`COURSE.${resp.response.result}`).then(function (result) {
              $scope.loadCoursesGroup();
              App.toast(result, 3000);
            });
          }
        });
      };

      $scope.current_course_group = {};
      $scope.manageCourseGroup = function (id) {
        $scope.isManage = true;
        Api.get(`courses/${courseId}/course-groups/${id}`, function (err, resp) {
          if (!err) {
            if (resp.response.data.modules_configurations) {
              for (let index = 0; index < resp.response.data.modules_configurations.length; index++) {
                const element = resp.response.data.modules_configurations[index];
                if (!element.activate_in || element.activate_in === '1969-12-31T03:00:00.000Z') {
                  resp.response.data.modules_configurations[index].activate_in = '';
                }
              }
            }
            $scope.current_course_group = resp.response.data;
            $scope.link2WebHookHotmart = `api.squidcommunity.com/webhook/hotmart/${$scope.project_id}/${$scope.current_course_group.id}`;
          }
        });
      };

      $scope.editSaveGroup = function () {
        $scope._fixDate();
        Api.put(`courses/${$scope.current_course_group.course_id}/course-groups/${$scope.current_course_group.id}`, $scope.current_course_group, function (err, resp) {
          if (err) {
            $translate('GLOBAL.ERROR').then((result) => App.toastError(result, 5000));
          }

          if (!err) {
            $translate(`COURSE.${resp.response.result}`).then(function (result) {
              App.toast(result, 3000);
              $scope.cancelEditSaveGroup();
              $scope.loadCoursesGroup();
            });
          }
        });
      };

      $scope._fixDate = function () {
        if ($scope.current_course_group.modules_configurations.length < 1) {
          return;
        }

        for (let index = 0; index < $scope.current_course_group.modules_configurations.length; index++) {
          const element = $scope.current_course_group.modules_configurations[index];
          if (element.activate_in) {
            let day = new Date(element.activate_in);
            if ($scope.lang == 'pt-br' && element.activate_in && typeof element.activate_in === 'string') {
              day = new Date(element.activate_in.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3'));
            }
            day.setHours(0, 0, 0);
            $scope.current_course_group.modules_configurations[index].activate_in = day.toISOString();
          } else {
            $scope.current_course_group.modules_configurations[index].activate_in = undefined;
          }
        }
      };

      $scope.cancelEditSaveGroup = function () {
        $scope.isManage = false;
        $scope.current_course_group = {};
      };

      $scope.changeDateModulesConfigurations = function (date) {
        if (date) {
          let day = new Date(date);
          const today = new Date();
          if ($scope.lang === 'pt-br' && date && typeof date === 'string') {
            day = new Date(date.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3'));
          }
          day.setHours(0, 0, 0);
          day.setMilliseconds(0);
          today.setHours(0, 0, 0);
          today.setMilliseconds(0);
          if (day.getTime() < today.getTime()) {
            $translate('MESSAGES.DATE_IS_EARLIER_THAN_THE_CURRENT_DATE').then(function (result) {
              App.toastError(result, 8000);
            });
          }
        }
      };

      $scope.calendar = {
        m: {
          'pt-br': ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
          en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
        },
        ms: {
          'pt-br': ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Aug', 'Set', 'Out', 'Nov', 'Dez'],
          en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        },
        wf: {
          'pt-br': ['Domingo', 'Segunda-Feira', 'Terça-Feira', 'Quarta-Feira', 'Quinta-Feira', 'Sexta-Feira', 'Sábado'],
          en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
        },
        wl: {
          'pt-br': ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
          en: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
        },
        td: {
          'pt-br': 'Hoje',
          en: 'Today'
        },
        clear: {
          'pt-br': 'Limpar',
          en: 'Clear'
        },
        close: {
          'pt-br': 'OK',
          en: 'OK'
        },
        dateformat: {
          'pt-br': 'dd/mm/yyyy',
          en: 'mm/dd/yyyy'
        }
      };
      const currentTime = new Date();
      $scope.currentTime = currentTime;
      $scope.month = $scope.calendar.m[$scope.lang];
      $scope.monthShort = $scope.calendar.ms[$scope.lang];
      $scope.weekdaysFull = $scope.calendar.wf[$scope.lang];
      $scope.weekdaysLetter = $scope.calendar.wl[$scope.lang];
      $scope.disable = [false, 1, 7];
      $scope.today = $scope.calendar.td[$scope.lang];
      $scope.clear = $scope.calendar.clear[$scope.lang];
      $scope.close = $scope.calendar.close[$scope.lang];
      $scope.dateformat = $scope.calendar.dateformat[$scope.lang];
      const days = 15;
      $scope.minDate = new Date($scope.currentTime.getTime() - 1000 * 60 * 60 * 24 * days).toISOString();
      $scope.maxDate = new Date($scope.currentTime.getTime() + 1000 * 60 * 60 * 24 * days).toISOString();
      const getLetterGroup = (i) => (i >= 26 ? getLetterGroup(Math.floor(i / 26) - 1) : '') + 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[i % 26];
      $(document).on('mousedown', '.picker__input', function (event) {
        event.preventDefault();
      });

      $scope.coProductions = [];
      $scope.coProducer = [];
      $scope.newCoProducer = false;
      $scope.isEditCoProducer = false;
      $scope.totalRevenue = 0;
      $scope.showMonetizationTabs = false;

      var editCoProducerItem = null;
      var showUnloadMsgCoProducer = false;
      $scope.enabledSplit = false;

      $scope.loadCoProductions = function () {
        Api.get(`monetization/split/course/${courseId}`, function (err, resp) {
          if (!err) {
            $scope.coProductions = [];
            for (var i in resp.response.data) {
              var coProducer = resp.response.data[i];
              var commission = coProducer.percentage_value / 100;
              commission = Math.round(commission * 100) / 100;
              $scope.coProductions.push({
                user: {
                  _id: coProducer.id,
                  name: coProducer.name,
                  slug: coProducer.slug,
                  job: coProducer.job,
                  company: coProducer.company,
                  image: coProducer.image,
                  banned: coProducer.banned
                },
                date: coProducer.join_date,
                commission: commission,
                terms: true
              });
              $scope.totalRevenue += commission;
              $scope.enabledSplit = true;
            }
          }
        });
      };

      $scope.loadCoProductions();

      $translate('COURSE.COPRODUCER_UNLOAD_MSG').then(function (result) {
        $('ul.tabs li').on('click', function (e) {
          if (showUnloadMsgCoProducer && !$(e.target).hasClass('active')) {
            if (confirm(result)) {
              showUnloadMsgCoProducer = false;
              return true;
            }
            return false;
          }
        });

        window.addEventListener('beforeunload', function (e) {
          if (showUnloadMsgCoProducer) {
            showUnloadMsgCoProducer = false;
            e.returnValue = result;
            return result;
          }
        });
      });

      $scope.onkeypressCoProducer = function (e, value) {
        var maxValue = 100 - $scope.totalRevenue;
        maxValue = Math.round(maxValue * 100) / 100;
        if (value >= maxValue) {
          $scope.coProducer.commission = maxValue;
          $translate('COURSE.COPRODUCER_COMMISSION_MAX').then(function (result) {
            App.toast(result + maxValue, 3000);
          });
        }
        if (value <= 0) {
          $scope.coProducer.commission = null;
        }
      };

      $scope.setNewCoProducer = function () {
        $scope.newUser = false;
        $scope.coProducer = [];
        $scope.isEditCoProducer = false;
        $scope.toogleCoProducer();
      };

      $scope.editCoProducer = function (p) {
        $scope.coProducer = {
          user: p.user,
          date: p.date,
          commission: p.commission,
          terms: p.terms
        };
        $scope.newUser = p.user;
        $scope.isEditCoProducer = true;
        $scope.toogleCoProducer();
        editCoProducerItem = p;
        $scope.totalRevenue -= p.commission;
        $scope.coProductions.splice(getUserIndexCoProducer(p.user), 1);
      };
      $scope.removeCoProducer = function (p) {
        var index = getUserIndexCoProducer(p.user);
        $scope.coProductions.splice(index, 1);
        $scope.totalRevenue -= p.commission;
        $translate('COURSE.COPRODUCER_REMOVE_OK').then(function (result) {
          App.toast(result, 3000);
        });
      };

      $scope.addCoProducer = function (form) {
        if (form.$invalid) {
          formNotify($scope, form);
          return false;
        }
        if (!$scope.newUser) {
          $translate('COURSE.ERROR_SELECT_USER').then(function (result) {
            App.toast(result, 3000);
          });
          return;
        }
        showUnloadMsgCoProducer = true;
        var index = getUserIndexCoProducer($scope.newUser);

        if (index >= 0) {
          $translate('COURSE.COPRODUCER_ADDED').then(function (result) {
            App.toast(result, 3000);
          });
          return false;
        }

        $scope.coProducer.date = new Date();
        $scope.coProducer.user = $scope.newUser;
        $scope.coProductions.push($scope.coProducer);
        $scope.totalRevenue += $scope.coProducer.commission;
        $scope.coProducer = [];
        editCoProducerItem = null;
        $translate('COURSE.COPRODUCER_ADD_OK').then(function (result) {
          App.toast(result, 3000);
        });
        $scope.toogleCoProducer();
      };

      $scope.saveCoProducer = function () {
        var maxValue = Math.round($scope.totalRevenue * 100) / 100;
        if (maxValue < 100) {
          $translate('COURSE.COPRODUCER_TOTAL_REVENUE').then(function (result) {
            App.toast(result, 3000);
          });
          return;
        }

        var splitPost = {
          coproducers: []
        };

        for (var i in $scope.coProductions) {
          splitPost.coproducers.push({
            user_id: $scope.coProductions[i].user._id,
            percentage_value: Math.round($scope.coProductions[i].commission * 100)
          });
        }

        Api.post(`monetization/split/course/${courseId}`, splitPost, function (err, ret) {
          showUnloadMsgCoProducer = false;
          if (!err) {
            $translate('COURSE.COPRODUCER_SAVE').then(function (result) {
              App.toast(result, 3000);
            });
          }
        });
      };
      $scope.toogleCoProducer = function () {
        $scope.newCoProducer = !$scope.newCoProducer;
        if ($scope.isEditCoProducer && editCoProducerItem) {
          $scope.coProductions.push(editCoProducerItem);
          $scope.totalRevenue += editCoProducerItem.commission;
          editCoProducerItem = null;
        }
      };

      $scope.toggleEnabledSplit = function () {
        $scope.enabledSplit = !$scope.enabledSplit;

        var data = {coproducers: []};
        if (!$scope.enabledSplit) {
          Api.post(`monetization/split/course/${courseId}`, data, function (err, resp) {
            if (!err) {
              $scope.coProductions = [];
            }
          });
        }
      };

      function getUserIndexCoProducer(user) {
        return $scope.coProductions.findIndex(function (i) {
          return i.user._id === user._id;
        });
      }
    }
  };
})();
